import type { InvoiceRow } from '../types';

export interface IssueActionCopy {
  readonly trigger: string;
  readonly present: string;
  readonly gerund: string;
  readonly pastAdjective: string;
}

const SELL_COPY: IssueActionCopy = {
  trigger: 'Issue',
  present: 'Issue',
  gerund: 'Issuing',
  pastAdjective: 'issued',
};

const BUY_COPY: IssueActionCopy = {
  trigger: 'Record Invoice',
  present: 'Record',
  gerund: 'Recording',
  pastAdjective: 'recorded',
};

// Only receivables are Metycle-issued ("Issue"); payables/unknown are supplier-issued and merely recorded here ("Record").
export function issueActionCopy(invoice: Pick<InvoiceRow, 'invoice_direction'>): IssueActionCopy {
  return invoice.invoice_direction === 'Sale' ? SELL_COPY : BUY_COPY;
}
